// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as LegacyIcon from "../../resources/images-and-icons/LegacyIcon.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as CatalogLabel from "./CatalogLabel.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let make = React.memo(props => {
  let __stateSettingsStorageUseRead = props.stateSettingsStorageUseRead;
  let onRequestNotification = props.onRequestNotification;
  let requestLabelsPrinting = props.requestLabelsPrinting;
  let requestBarcodeCompletion = props.requestBarcodeCompletion;
  let shopId = props.shopId;
  let variantId = props.variantId;
  let stateSettingsStorageUseRead = __stateSettingsStorageUseRead !== undefined ? __stateSettingsStorageUseRead : CatalogLabel.StateSettingsUserPreferences.useRead;
  let printSettings = stateSettingsStorageUseRead();
  let match = React.useState(() => 1);
  let setPrintingQuantity = match[1];
  let printingQuantity = match[0];
  let navigate = Navigation.useNavigate();
  let match$1 = Navigation.useUrl();
  let editRedirectionQueryString = CatalogRoutes.CatalogLabelQueryString.encode({
    variantIdfromLabelEditSettings: variantId,
    fromPathname: match$1.pathname
  });
  let hasSettings = printSettings !== undefined ? printSettings.labelFormat.TAG !== "LabelSheet" : false;
  let onCommit = () => {
    if (!hasSettings) {
      return navigate(undefined, CatalogRoutes.labelsCreateSettingsRoute + "?" + editRedirectionQueryString);
    }
    if (printSettings === undefined) {
      return;
    }
    let labelFormat = printSettings.labelFormat;
    if (labelFormat.TAG === "LabelSheet") {
      return;
    } else {
      return Future.get(CatalogLabel.Print.CombineRequests.make(requestBarcodeCompletion, requestLabelsPrinting, printSettings.priceId, printSettings.priceName, printSettings.productCode, printSettings.productBarcodeDisplayed, {
        TAG: "Picked",
        _0: [{
          variantId: variantId,
          repetitions: printingQuantity | 0
        }]
      }, labelFormat._0, printSettings.missingProductBarcodeGenerated, printSettings.priceDisplayed, printSettings.producerDisplayed, printSettings.alcoholVolumeDisplayed, printSettings.designationDisplayed, shopId), result => {
        if (result.TAG === "Ok") {
          return onRequestNotification({
            TAG: "Ok",
            _0: I18n.template(printingQuantity > 1 ? I18n.t("{{quantity}} prints of the label has been started.") : I18n.t("{{quantity}} print of the label has been started."), {
              quantity: printingQuantity
            }, undefined) + I18n.template(I18n.t("[Monitor printing from your StarPrinter Online account]({{link}})"), {
              link: "https://portal.starprinter.online/Dashboard"
            }, undefined)
          });
        } else {
          return onRequestNotification({
            TAG: "Error",
            _0: result._0
          });
        }
      });
    }
  };
  let modalContentElement;
  let exit = 0;
  if (printSettings !== undefined) {
    let labelFormat = printSettings.labelFormat;
    if (labelFormat.TAG === "LabelSheet") {
      exit = 1;
    } else {
      let match$2 = printSettings.productCode;
      let tmp;
      switch (match$2) {
        case "Hidden":
          tmp = null;
          break;
        case "SKU":
          tmp = I18n.t("Display SKU");
          break;
        case "InternalCode":
          tmp = I18n.t("Display internal code");
          break;
      }
      modalContentElement = JsxRuntime.jsxs(Stack.make, {
        children: [props.fromEditRedirection ? JsxRuntime.jsx(Banner.make, {
          textStatus: {
            TAG: "Success",
            _0: I18n.t("Print parameters set correctly!")
          }
        }) : null, JsxRuntime.jsx(InputNumberField.make, {
          value: printingQuantity,
          minValue: 1,
          precision: 0,
          label: I18n.t("Copies"),
          onChange: value => setPrintingQuantity(param => value)
        }), JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Card.make, {
            children: JsxRuntime.jsxs(Stack.make, {
              children: [JsxRuntime.jsxs(Stack.make, {
                children: [JsxRuntime.jsx(TextStyle.make, {
                  children: printSettings.priceName
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.template(I18n.t("Format: {{format}}"), {
                    format: CatalogLabel.Print.LabelFormat.toFormatLabel(labelFormat._0)
                  }, undefined)
                })]
              }), JsxRuntime.jsxs(Stack.make, {
                children: [printSettings.productBarcodeDisplayed ? JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("Display barcode") + (printSettings.missingProductBarcodeGenerated ? " " + I18n.t("(generate automatically if missing)") : "")
                }) : null, printSettings.priceDisplayed ? JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("Display retail price")
                }) : null, printSettings.producerDisplayed ? JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("Display producer")
                }) : null, printSettings.alcoholVolumeDisplayed ? JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("Display alcohol volume")
                }) : null, printSettings.designationDisplayed ? JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("Display designation")
                }) : null, JsxRuntime.jsx(TextStyle.make, {
                  children: tmp
                })]
              })],
              space: "normal"
            }),
            title: I18n.t("Print settings"),
            action: {
              icon: "legacy_edit",
              title: I18n.t("Edit settings"),
              href: CatalogRoutes.labelsCreateSettingsRoute + "?" + editRedirectionQueryString
            }
          }),
          style: {
            border: "1px solid #d7d7e0",
            borderRadius: "4px"
          }
        })],
        space: "large"
      });
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    modalContentElement = JsxRuntime.jsx(Placeholder.make, {
      status: {
        TAG: "Pending",
        title: I18n.t("No print settings set"),
        message: I18n.t("To print a label from a product page, you must first enter the print settings."),
        illustration: Primitive_option.some(Illustration.warningTriangle)
      }
    });
  }
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: modalContentElement,
      spaceX: "large",
      spaceTop: "xlarge",
      spaceBottom: "large"
    }),
    opened: props.opened,
    title: I18n.t("Print label"),
    abortButtonText: I18n.t("Cancel"),
    commitButtonTone: "brand",
    commitButtonText: hasSettings ? I18n.t("Print label") : I18n.t("Set settings"),
    commitButtonCallback: onCommit,
    onRequestClose: props.onRequestClose
  });
});
let CatalogLabelQuickPrintModal = {
  make: make
};
let styles = {
  buttonBackbone: {
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-x1q0g3np",
    "height-kZKoxP": "height-x5kalc8",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "paddingInline-kg3NbH": "paddingInline-x4l9tsp",
    $$css: "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:214"
  },
  buttonTextLocked: {
    "color-kMwMTN": "color-x1lewwgq",
    "font-kVVagm": "font-x36xucc",
    $$css: "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:223"
  },
  overlayBackbone: {
    "padding-kmVPX3": "padding-x1tamke2",
    "width-kzqmXN": "width-x1l2rt3b",
    $$css: "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:227"
  },
  overlayTitleText: {
    "color-kMwMTN": "color-x1lewwgq",
    "font-kVVagm": "font-x1as1man",
    $$css: "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:231"
  },
  overlayTitleIcon: {
    "backgroundColor-kWkggS": "backgroundColor-x1kax95x",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "display-k1xSpc": "display-x78zum5",
    "padding-kmVPX3": "padding-x1ruevkc",
    $$css: "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:235"
  },
  overlayButtonStyle: {
    "backgroundColor-kWkggS": "backgroundColor-x1kax95x",
    "borderColor-kVAM5u": "borderColor-xz3ntf8",
    $$css: "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:241"
  }
};
function buttonStyleFromParams(hovered, active) {
  if (active) {
    return {
      backgroundColor: "#f4e4ee",
      borderColor: "#8a0262"
    };
  } else if (hovered) {
    return {
      backgroundColor: "#f4e4ee"
    };
  } else {
    return {};
  }
}
let make$1 = React.memo(props => {
  let match = Hover.use(undefined, undefined, undefined);
  let newrecord = {
    ...{
      className: "padding-x1tamke2 width-x1l2rt3b",
      "data-style-src": "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:227"
    }
  };
  let newrecord$1 = {
    ...{
      className: "backgroundColor-x1kax95x borderRadius-x1sxf85j display-x78zum5 padding-x1ruevkc",
      "data-style-src": "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:235"
    }
  };
  let newrecord$2 = {
    ...{
      className: "color-x1lewwgq font-x1as1man",
      "data-style-src": "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:231"
    }
  };
  let newrecord$3 = {
    ...Stylex.props(styles.buttonBackbone, styles.buttonTextLocked, styles.overlayButtonStyle, buttonStyleFromParams(match[1], false))
  };
  let newrecord$4 = {
    ...{
      className: "color-x1lewwgq font-x36xucc",
      "data-style-src": "wino-gc:src/modules/Catalog/CatalogLabelQuickPrintButton.res.js:223"
    }
  };
  newrecord$3.children = JsxRuntime.jsx("span", (newrecord$4.children = I18n.t("Get the feature"), newrecord$4));
  newrecord.children = JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsx(LegacyIcon.make, {
        name: "printer_locked",
        fill: "#a01e72",
        size: 20
      }), newrecord$1)), JsxRuntime.jsx("span", (newrecord$2.children = I18n.t("Print label"), newrecord$2))],
      space: "normal"
    }), JsxRuntime.jsx(TextStyle.make, {
      children: I18n.t(I18n.t("This new feature lets you print a label directly from a product page with a Star printer."))
    }), JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsx("div", newrecord$3),
      onPress: param => HelpCenter.showArticle(HelpCenter.getLabelPrintFeature),
      ref: match[0]
    })],
    space: "xmedium"
  });
  return JsxRuntime.jsx(Popover.make, {
    children: JsxRuntime.jsx(Popover.Dialog.make, {
      children: JsxRuntime.jsx("div", newrecord),
      ariaProps: props.overlayProps
    }),
    triggerRef: props.triggerRef,
    state: props.state,
    borderColor: "#a01e72",
    placement: "bottom start",
    modal: false
  });
});
let CatalogLabelQuickPrintButtonPopover = {
  make: make$1
};
let make$2 = React.memo(props => {
  let __stateSettingsStorageUseRead = props.stateSettingsStorageUseRead;
  let onRequestNotification = props.onRequestNotification;
  let requestLabelsPrinting = props.requestLabelsPrinting;
  let requestBarcodeCompletion = props.requestBarcodeCompletion;
  let shopId = props.shopId;
  let variantId = props.variantId;
  let __fromEditRedirection = props.fromEditRedirection;
  let variation = props.variation;
  let fromEditRedirection = __fromEditRedirection !== undefined ? __fromEditRedirection : false;
  let stateSettingsStorageUseRead = __stateSettingsStorageUseRead !== undefined ? __stateSettingsStorageUseRead : CatalogLabel.StateSettingsUserPreferences.useRead;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popover = match.state;
  let match$1 = React.useState(() => fromEditRedirection);
  let setPrintModalOpened = match$1[1];
  let printModalOpened = match$1[0];
  let handleOnPress = param => {
    if (typeof variation === "object" && variation.NAME === "button" && variation.VAL.featureLocked) {
      return popover.toggle();
    }
    setPrintModalOpened(param => true);
  };
  if (typeof variation === "object") {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [variation.VAL.featureLocked ? JsxRuntime.jsx(Button.make, {
        label: I18n.t("Print label"),
        tone: "brand",
        active: popover.isOpen,
        icon: "printer_locked",
        onPress: handleOnPress,
        ref: popoverTriggerRef
      }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [JsxRuntime.jsx(Button.make, {
          label: I18n.t("Print label"),
          icon: "printer",
          onPress: handleOnPress
        }), JsxRuntime.jsx(make, {
          fromEditRedirection: fromEditRedirection,
          variantId: variantId,
          shopId: shopId,
          requestBarcodeCompletion: requestBarcodeCompletion,
          requestLabelsPrinting: requestLabelsPrinting,
          opened: printModalOpened,
          onRequestClose: () => setPrintModalOpened(param => false),
          onRequestNotification: onRequestNotification,
          stateSettingsStorageUseRead: stateSettingsStorageUseRead
        })]
      }), popover.isOpen ? JsxRuntime.jsx(make$1, {
        triggerRef: popoverTriggerRef,
        state: popover,
        overlayProps: match.ariaProps.overlayProps
      }) : null]
    });
  } else {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [JsxRuntime.jsx(Tooltip.make, {
        children: JsxRuntime.jsx(Button.make, {
          variant: "subtle",
          size: "small",
          active: printModalOpened,
          icon: "printer",
          onPress: handleOnPress,
          ref: popoverTriggerRef
        }),
        arrowed: false,
        placement: "top end",
        content: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("Print label")
        }),
        closeDelay: 0
      }), JsxRuntime.jsx(make, {
        fromEditRedirection: fromEditRedirection,
        variantId: variantId,
        shopId: shopId,
        requestBarcodeCompletion: requestBarcodeCompletion,
        requestLabelsPrinting: requestLabelsPrinting,
        opened: printModalOpened,
        onRequestClose: () => setPrintModalOpened(param => false),
        onRequestNotification: onRequestNotification,
        stateSettingsStorageUseRead: stateSettingsStorageUseRead
      })]
    });
  }
});
export { CatalogLabelQuickPrintModal, styles, buttonStyleFromParams, CatalogLabelQuickPrintButtonPopover, make$2 as make };
/* make Not a pure module */